// extracted by mini-css-extract-plugin
export default {"mainSection":"MainSection_mainSection__sMv5j","pagination":"MainSection_pagination__yNSn0"};